import type { SparklineWidget } from '../../../widgets';
import {
  BindingRow,
  NumberField,
  Row,
  Section,
  patcher,
  rangeError,
  type WidgetEditorProps,
} from '../fields';

/** Verlaufsstrich. Die vier Schwellen sind optional und einzeln abschaltbar:
 *  leer heisst "keine Schwelle", nicht "Schwelle bei null". */
export function SparklineEditor(
  { widget, plantId, onChange }: WidgetEditorProps<SparklineWidget>,
) {
  const patch = patcher(widget, onChange);
  const warn = rangeError(widget.warnLow ?? undefined, widget.warnHigh ?? undefined);
  const alarm = rangeError(widget.alarmLow ?? undefined, widget.alarmHigh ?? undefined);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Wert-Datenpunkt"
          value={widget.valuePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ valuePoint: next })}
        />
      </Section>
      <Section
        title="Fenster"
        hint="Gezeichnet wird aus dem Ringpuffer der laufenden Sitzung, nicht aus der Historie."
      >
        <NumberField
          label="Anzahl Messwerte"
          value={widget.windowSize}
          min={2}
          max={512}
          integer
          onChange={(next) => patch({ windowSize: next })}
        />
      </Section>
      <Section
        title="Schwellen"
        hint="Leer heißt: keine Schwelle. Der Strich bleibt dann immer neutral."
      >
        <Row>
          <NumberField
            label="Warnung unten"
            value={widget.warnLow}
            error={warn}
            onChange={(next) => patch({ warnLow: next ?? null })}
          />
          <NumberField
            label="Warnung oben"
            value={widget.warnHigh}
            error={warn ? ' ' : undefined}
            onChange={(next) => patch({ warnHigh: next ?? null })}
          />
        </Row>
        <Row>
          <NumberField
            label="Alarm unten"
            value={widget.alarmLow}
            error={alarm}
            onChange={(next) => patch({ alarmLow: next ?? null })}
          />
          <NumberField
            label="Alarm oben"
            value={widget.alarmHigh}
            error={alarm ? ' ' : undefined}
            onChange={(next) => patch({ alarmHigh: next ?? null })}
          />
        </Row>
      </Section>
    </>
  );
}
